import {
  FDHeadlineText,
} from '@facet-wealth/design';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';

export default buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDHeadlineText,
    _customProps: {
      align: 'center',
    },
  }, overrideReadOnly)
  .done();
